module.exports = __webpack_public_path__ + "img/bg2.cf81f622.jpg";